import React from "react"
import { NavLink } from "react-router-dom"
import { Grid, Icon, Card } from "semantic-ui-react"

export const Employer = ({ id, name, household_id, description, baseUrl }) => (
  <Card>
    <Card.Content>
      <Grid>
        <Grid.Row>
          <Grid.Column textAlign="left">
            {household_id ? (
              <NavLink to={`${baseUrl}/employer/${id}`} className="navlink">
                <span className="GenericCard__LinkTitle">
                  {name}
                  <Icon name="chevron right" size="small" />
                </span>
              </NavLink>
            ) : (
              <p style={{ fontSize: "1.3em", margin: "0px" }}>{name}</p>
            )}
            <p className="greyed-text">{description}</p>
          </Grid.Column>
        </Grid.Row>
      </Grid>
    </Card.Content>
  </Card>
)
